import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const getNewsPage = gql`
  ${seoFragment}
  query getNewsPage($site: [String]) {
    newsPageEntries(site: $site) {
      ... on newsPage_Entry {
        id
        seo {
          ...SeoFragment
        }
        notiziaInEvidenza {
          ... on news_Entry {
            slug
            title
            introNews {
              html
            }
            sezioneContenutoPagina {
              ... on immagine_Entry {
                custom: immagine @transform(format: "webp", width: 1800) {
                  id
                  url
                  width
                  height
                  title
                }
              }
              ... on immagineTradotta_Entry {
                custom: immagineTradotta
                  @transform(format: "webp", width: 1800) {
                  id
                  url
                  width
                  height
                  title
                }
              }
            }
          }
        }
        notizieInEvidenza {
          ... on news_Entry {
            slug
            title
            sezioneContenutoPagina {
              ... on immagine_Entry {
                custom: immagine @transform(format: "webp", width: 740) {
                  id
                  url
                  width
                  height
                  title
                }
              }
              ... on immagineTradotta_Entry {
                custom: immagineTradotta
                  @transform(format: "webp", width: 1800) {
                  id
                  url
                  width
                  height
                  title
                }
              }
            }
          }
        }
        video {
          ... on video_Entry {
            title
            linkDefault
            portrait: immagine
              @transform(format: "webp", width: 880, height: 500) {
              id
              url
              srcset(sizes: ["750w", "1000w"])
              width
              height
              title
            }
          }
        }
        campagne {
          ... on campagna_Entry {
            sectionTitle
            file {
              url
            }
            portrait: immagine
              @transform(format: "webp", width: 880, height: 500) {
              id
              url
              srcset(sizes: ["750w", "1000w"])
              width
              height
              title
            }
          }
        }
      }
    }
  }
`
